import StoredLayout from '../../layouts/StoredLayout'
import VectorMaps from './VectorMaps'
export default StoredLayout(VectorMaps)
